import cn from 'classnames'
import { tr } from 'mmfintech-commons'
import AppstoreIcon from '@images/icons/appstore-app-icon.svg?react'
import settings from '@settings'
import { Link } from 'react-router-dom'

import styles from './downloadAppButtons.module.scss'

export const AppStoreButton = () => {
  return (
    <div
      className={cn(styles['download-app-link'], 'download-app-link')}
      data-coming-soon={tr('FRONTEND.DOWNLOAD_APP.COMING_SOON', 'Coming soon')}
    >
      <Link to={{ pathname: settings.appStoreUrl }} target='_blank' data-test='download-app-appstore'>
        <AppstoreIcon data-test='download-app-appstore-icon' />
      </Link>
    </div>
  )
}
